import React from "react";
import { useState } from "react";
import TestCard from "./Components/TestCard";
import "./TestsQuiz.scss";
import { Link } from "react-router-dom";
import PATH from "../../constants/routes";

type TestType = {
  testDate: string;
  testTitle: string;
  testStatus: string;
};

const testPrototype: TestType = {
  testDate: "2022/12/21 05:00 p.m",
  testTitle: "Revision Test XXII",
  testStatus: "Completed",
};

export default function Tests() {
  const [tests, setTests] = useState<TestType[]>([testPrototype, testPrototype, testPrototype, testPrototype, testPrototype]);

  const renderTests = () => {
    return tests.map((test, index) => {
      return (
        <Link key={index} to={`${index}/${PATH.PLAY_TEST_LINK}`}>
          <TestCard test={test} />
        </Link>
      );
    });
  };

  return (
    <div className="tests">
      <h2 className="list_heading">2022</h2>
      <div className="test_list_container list_container">{renderTests()}</div>
    </div>
  );
}
